import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useEffect } from 'react'
import toast, { Toaster, useToasterStore } from 'react-hot-toast'
import { BrowserRouter as Router } from 'react-router-dom'

import PageRoutes from './components/container/PageRoutes'
import { toastLimit } from './configs/app'
import { defaultOptions } from './configs/react-query'
import { AuthProvider } from './contexts/AuthContext'

const queryClient = new QueryClient(defaultOptions)

function App() {
  const { toasts } = useToasterStore()

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= toastLimit)
      .forEach((t) => toast.dismiss(t.id))
  }, [toasts])

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <Router>
        <AuthProvider>
          <PageRoutes />
        </AuthProvider>
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App
